import { IHttpService, IPromise } from "angular";
import { IAuditLog } from "@gtmhub/configuration";
import { IRestLayerRequest } from "@gtmhub/core";
import { EnvironmentService } from "@gtmhub/env";
import { ICollection } from "@webapp/core/root/models/root.models";

export interface IAuditLogQuery extends IRestLayerRequest {
  take?: number;
  targets?: string;
  ownerIds?: string;
  action?: string;
  type?: string;
  startDate?: string;
  endDate?: string;
}

export class AuditLogService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public getAuditLog<T extends IAuditLog>(params: IAuditLogQuery): IPromise<ICollection<T>> {
    const queryParams = [];
    const qParams = [];
    if (params.ownerIds) {
      qParams.push(`ownerIds:${params.ownerIds}`);
    }

    if (params.type) {
      qParams.push(`targets:${params.type}`);
    }

    if (params.action) {
      qParams.push(`kinds:${params.action}`);
    }

    if (params.startDate) {
      queryParams.push(`startDate=${this.formatDate(params.startDate)}`);
    }

    if (params.endDate) {
      queryParams.push(`endDate=${this.formatDate(params.endDate)}`);
    }

    if (params.take) {
      queryParams.push(`take=${params.take}`);
    }

    if (params.skip) {
      queryParams.push(`skip=${params.skip}`);
    }

    if (params.sort) {
      queryParams.push(`sort=${params.sort.replace("dateTime", "created")}`);
    }

    let q;

    if (qParams.length > 0) {
      q = `?q=${qParams.join()}&${queryParams.join("&")}`;
    } else {
      q = `?${queryParams.join("&")}`;
    }

    const url = this.env.getMomentsEndpoint(`/audit-log${q}`);

    return this.$http.get<ICollection<T>>(url).then((response) => response.data);
  }

  public getOptions = () => {
    const url = this.env.getMomentsEndpoint(`/audit-log-options`);

    return this.$http.get(url).then((response) => response.data);
  };

  formatDate = (date: string) => {
    const dateObj = new Date(date);
    const dayAsTwoDigit = dateObj.toLocaleString("en", { day: "2-digit" });
    const monthAsShort = dateObj.toLocaleString("en", { month: "2-digit" });
    return `${dateObj.getFullYear()}-${monthAsShort}-${dayAsTwoDigit}`;
  };
}
